import type { Messages } from "@/i18n/messages/sq"

export const ar: Messages = {
    meta: {
        lang: "ar",
        dir: "rtl",
        siteTagline: "نشر وترجمة ودورات تعليمية",
        siteDescription:
            "معهد جيرما مؤسسة ثقافية وتعليمية تعمل في مجالات النشر والترجمة ودورات القرآن الكريم وتعليم اللغات الأجنبية."
    },

    languageNames: {
        sq: "الألبانية",
        en: "الإنجليزية",
        de: "الألمانية",
        es: "الإسبانية",
        tr: "التركية",
        bs: "البوسنية",
        ar: "العربية"
    },

    common: {
        home: "الرئيسية",
        homeAria: "معهد جيرما، الصفحة الرئيسية",
        breadcrumb: "مسار الصفحة",
        mainNav: "القائمة الرئيسية",
        menu: "القائمة",
        openMenu: "فتح القائمة",
        closeMenu: "إغلاق القائمة",
        contactUs: "تواصل معنا",
        language: "اللغة",
        chooseLanguage: "اختر لغة الموقع",
        instituteName: "معهد جيرما"
    },

    nav: {
        libra: "الكتب",
        kurani: "القرآن الكريم",
        videoleksione: "الدروس المرئية",
        kurse: "الدورات",
        audiolibra: "الكتب الصوتية",
        rrethNesh: "من نحن",
        kontakt: "اتصل بنا"
    },

    footer: {
        tagline:
            "ننشر الكتب الإسلامية ونترجمها، ونقدّم دورات في قراءة القرآن الكريم وتعلّم اللغات الأجنبية.",
        links: "روابط سريعة",
        books: "الكتب",
        allBooks: "جميع الكتب",
        contact: "التواصل",
        contactNote:
            "راسلنا لطلب الكتب أو للتسجيل في الدورات أو لاقتراح تعاون.",
        rights: "جميع الحقوق محفوظة."
    },

    verse: {
        text: "﴿وَقُل رَّبِّ زِدْنِي عِلْمًا﴾",
        source: "سورة طه، الآية 114"
    },

    home: {
        seoDescription:
            "كتب مجانية للتحميل، ودروس مرئية، وكتب صوتية، ودورات في قراءة القرآن الكريم وتعلّم اللغات من معهد جيرما.",
        hero: {
            eyebrow: "أهلًا وسهلًا",
            intro:
                "معهد جيرما مؤسسة ثقافية وتعليمية. ننشر الكتب الدينية واللغوية والتربوية، ونُعدّ الدروس المرئية، وننظّم دورات في قراءة القرآن الكريم وتعلّم اللغات الأجنبية.",
            primaryCta: "تصفّح إصداراتنا",
            secondaryCta: "سجّل في الدورات",
            pillars: ["الكتب", "الدروس المرئية", "الدورات", "الكتب الصوتية"],
            cue: "اكتشف المزيد",
            category: "إصدار",
            viewBook: "عرض الكتاب",
            previous: "الكتاب السابق",
            next: "الكتاب التالي",
            goTo: "الانتقال إلى الكتاب {number}"
        },
        marquee: {
            rowOne: ["النشر", "الترجمة", "دورات القرآن", "الدروس المرئية", "الكتب الصوتية", "اللغات الأجنبية"],
            rowTwo: ["الأبجدية القرآنية", "التجويد", "العلم", "التربية", "التراث", "منهج معاصر"]
        },
        about: {
            eyebrow: "عن المعهد",
            title: "في خدمة العلم والتعليم",
            intro:
                "نسعى في عملنا إلى مساعدة الناس على التعلّم، وعلى معرفة دينهم معرفة أعمق، وتنمية مهاراتهم اللغوية. ولذلك نحرص على أن تكون كتبنا وموادنا التعليمية دقيقة المحتوى واضحة الشرح، وأن تراعي دوراتنا مستوى الدارسين واحتياجاتهم.",
            features: [
                "نشر الكتب الدينية واللغوية والتربوية وترجمتها.",
                "دورات في قراءة القرآن الكريم وتعلّم اللغات الأجنبية، عن بُعد وحضوريًا.",
                "دروس مرئية وكتب صوتية يمكنك متابعتها عبر الإنترنت."
            ]
        },
        stats: {
            titles: "العناوين المنشورة",
            languages: "لغات النشر",
            fields: "مجالات العمل",
            online: "إتاحة عبر الإنترنت"
        },
        services: {
            eyebrow: "ما نقدّمه",
            title: "مجالات عملنا",
            more: "اعرف المزيد",
            items: {
                libra: {
                    title: "الكتب",
                    description:
                        "كتب دينية ولغوية وتربوية من إعداد معهد جيرما أو ترجمته.",
                    cta: "تصفّح الكتب"
                },
                videoleksione: {
                    title: "الدروس المرئية",
                    description: "دروس مصوّرة في قراءة القرآن الكريم وموضوعات دينية وتربوية أخرى.",
                    cta: "شاهد الدروس"
                },
                kurse: {
                    title: "الدورات",
                    description: "دورات في قراءة القرآن الكريم وتعلّم اللغات الأجنبية، حضوريًا وعن بُعد.",
                    cta: "تعرّف على الدورات"
                },
                audiolibra: {
                    title: "الكتب الصوتية",
                    description: "إصداراتنا مسجّلةً بالصوت، لمن يفضّل الاستماع.",
                    cta: "استمع إلى الكتب الصوتية"
                }
            }
        },
        booksLocal: {
            title: "كتب باللغة العربية",
            description: "إصداراتنا باللغة العربية، وكلها متاحة للتحميل مجانًا."
        },
        booksOther: {
            title: "كتب بلغات أخرى",
            description: "إصداراتنا باللغة الألبانية ولغات أخرى، وهي أيضًا متاحة للتحميل مجانًا."
        },
        booksCarouselTitle: "كتب تترك أثرًا",
        booksCarouselDescription:
            "أعمال دينية وتربوية وثقافية، أُعدّت بعناية للقارئ.",
        seeAllBooks: "عرض جميع الكتب",
        mostRead: {
            eyebrow: "اختيار القرّاء",
            title: "الأكثر قراءة",
            description: "الكتب التي يفتحها قرّاؤنا ويحمّلونها أكثر من غيرها."
        },
        kurani: {
            badge: "مشروع متميّز",
            title: "القرآن الكريم",
            subtitle: "ترجمة معانيه إلى اللغة الألبانية",
            text: "اقرأ القرآن الكريم مع ترجمة معانيه إلى اللغة الألبانية التي أعدّها يوسف كاستراتي، وهي متاحة مجانًا على موقع Kurani.info.",
            cta: "عن الترجمة",
            readOn: "اقرأ على Kurani.info",
            logoAlt: "شعار منصة Kurani.info",
            highlights: [
                {
                    title: "الدقة والأمانة",
                    text: "نقلٌ متأنٍّ لمعاني الآيات، بالاعتماد على كتب التفسير المعتمدة."
                },
                {
                    title: "ألبانية واضحة سلسة",
                    text: "لغة ألبانية طبيعية تحرص، قدر ما تسمح به اللغة، على الحفاظ على خصائص الأسلوب القرآني."
                },
                {
                    title: "حواشٍ توضيحية",
                    text: "تعليقات موجزة تُعين على فهم الآيات حيث تدعو الحاجة."
                }
            ]
        }
    },

    cta: {
        eyebrow: "انضم إلينا",
        title: "للتسجيل في الدورات أو طلب إصداراتنا أو التعاون معنا، تواصل معنا.",
        primary: "تعرّف على الدورات",
        secondary: "تواصل معنا"
    },

    books: {
        seoTitle: "كتب إسلامية",
        seoDescription:
            "فهرس إصدارات معهد جيرما: كتب دينية وتربوية وثقافية بالعربية والألبانية ولغات أخرى، بترجمة وتحرير احترافيين.",
        listName: "إصدارات معهد جيرما",
        title: "إصداراتنا",
        description:
            "تجد هنا إصداراتنا بالعربية والألبانية ولغات أخرى، وكلها متاحة للتحميل مجانًا.",
        crumb: "الكتب",
        searchLabel: "البحث في الكتب",
        searchPlaceholder: "ابحث بالعنوان أو المؤلف",
        authorChip: "المؤلف: {name}",
        clearAuthor: "إزالة تصفية المؤلف",
        clearSearch: "مسح البحث",
        categoryLabel: "التصنيف",
        allCategories: "جميع التصنيفات",
        languageLabel: "اللغة",
        allLanguages: "جميع اللغات",
        readingList: "قائمة قراءتي",
        readingListHintBefore: "اضغط على علامة",
        readingListHintAfter: "في أي كتاب لحفظه هنا.",
        readingListEmpty:
            "قائمة قراءتك فارغة حاليًا. اضغط على علامة الحفظ في أي كتاب تودّ قراءته لاحقًا.",
        foundOne: "تم العثور على كتاب واحد",
        foundMany: "عدد الكتب: {count}",
        noResults: "لا توجد كتب مطابقة لهذه المعايير.",
        showAll: "عرض جميع الكتب",
        groupLocal: "باللغة العربية",
        groupOther: "بلغات أخرى",
        mostRead: "الأكثر قراءة",
        publishedBy: "من إصدارات معهد جيرما",
        viewBook: "عرض كتاب {title}",
        coverAlt: "غلاف كتاب {title}",
        save: "احفظ في قائمتي",
        saved: "في قائمتي",
        remove: "إزالة من قائمتي"
    },

    bookPage: {
        lang: "ar",
        dir: "rtl",
        about: "عن الكتاب",
        highlights: "أبرز النقاط",
        details: "التفاصيل",
        language: "اللغة",
        languageName: "العربية",
        category: "التصنيف",
        author: "المؤلف",
        authorLine: "المؤلف: {author}.",
        publishedBy: "من إصدارات معهد جيرما.",
        fallbackDescription: "{title}. كتاب باللغة {language}.",
        publisher: "الناشر",
        cta: "هل يهمّك هذا الكتاب؟ راسلنا لطلبه أو لمزيد من المعلومات.",
        contact: "تواصل معنا",
        home: "الرئيسية",
        books: "الكتب",
        book: "كتاب",
        breadcrumb: "مسار الصفحة",
        coverAlt: "غلاف كتاب {title}",
        readOnline: "اقرأ على الإنترنت",
        orderOrAsk: "اطلب أو استفسر",
        allBooks: "جميع الكتب",
        readerTitle: "اقرأ الكتاب على الإنترنت",
        readerText: "تصفّح الكتاب كاملًا هنا مجانًا.",
        openNewTab: "افتح في علامة تبويب جديدة",
        relatedEyebrow: "تابع القراءة",
        moreByAuthor: "كتب أخرى للمؤلف",
        allByAuthor: "جميع كتب المؤلف",
        authorLinkTitle: "عرض كتب هذا المؤلف",
        relatedTitle: "قد يهمك أيضًا",
        seeAllBooks: "عرض جميع الكتب",
        otherEditions: "هذا الكتاب بلغات أخرى",
        watchVideos: "شاهد الدروس المرئية",
        downloadPdf: "تحميل PDF",
        continueFrom: "تابع من الصفحة {page}",
        startOver: "ابدأ من البداية",
        page: "الصفحة",
        pageOf: "من",
        prevPage: "الصفحة السابقة",
        nextPage: "الصفحة التالية",
        zoomIn: "تكبير",
        zoomOut: "تصغير",
        fullscreen: "ملء الشاشة",
        closeReader: "إغلاق القارئ",
        loadingBook: "جارٍ فتح الكتاب…",
        readerError: "تعذّر فتح الكتاب هنا. جرّب فتحه في علامة تبويب جديدة.",
        saveBook: "احفظ في قائمتي",
        savedBook: "في قائمتي",
        share: "مشاركة",
        copyLink: "نسخ الرابط",
        linkCopied: "تم نسخ الرابط",
        email: "البريد الإلكتروني",
        moreOptions: "خيارات أخرى",
        displaySettings: "طريقة العرض",
        themeLight: "نهار",
        themeSepia: "سيبيا",
        themeNight: "ليل",
        pageSize: "حجم النص",
        reviews: {
            title: "تقييمات القراء",
            intro: "ما رأيك في هذا الكتاب؟ اترك تقييمًا بالنجوم، وإن شئت كلمات قليلة لبقية القراء.",
            average: "{average} من 5",
            count: "عدد التقييمات: {count}",
            countOne: "تقييم واحد",
            empty: "لا توجد تقييمات لهذا الكتاب بعد. كن أول من يقيّمه.",
            formTitle: "قيّم هذا الكتاب",
            ratingLabel: "تقييمك",
            star: "عدد النجوم: {count}",
            starOne: "نجمة واحدة",
            name: "اسمك",
            namePlaceholder: "مثلًا: مريم",
            comment: "تعليق (اختياري)",
            commentPlaceholder: "ما الذي أعجبك في هذا الكتاب؟",
            submit: "أرسل التقييم",
            sending: "جارٍ الإرسال…",
            success: "شكرًا لك! سيظهر تقييمك بعد أن يراجعه المعهد.",
            errorRating: "يُرجى اختيار عدد النجوم التي تمنحها للكتاب.",
            errorName: "يُرجى كتابة اسمك (حرفان على الأقل).",
            errorThrottled: "لقد أرسلت تقييمات كثيرة اليوم. يُرجى المحاولة غدًا.",
            error: "تعذّر إرسال التقييم. يُرجى المحاولة بعد قليل.",
            moderated: "تظهر التقييمات بعد أن يراجعها المعهد."
        },
        quote: {
            button: "شارك اقتباسًا",
            title: "شارك اقتباسًا",
            intro: "حدّد جملة في صفحة الكتاب بالفأرة أو بإصبعك، أو اكتبها هنا. سنحوّلها إلى صورة لإنستغرام أو واتساب.",
            textLabel: "الاقتباس",
            placeholder: "اكتب أو الصق الجملة التي أثّرت فيك…",
            formatLabel: "شكل الصورة",
            square: "مربّع (منشور)",
            story: "طولي (قصة)",
            share: "شارك الصورة",
            download: "نزّل الصورة",
            copyText: "انسخ النص",
            copied: "نُسخ النص",
            close: "إغلاق",
            tooLong: "الاقتباس طويل جدًا. يُرجى اختصاره (حتى {max} حرفًا).",
            empty: "اكتب اقتباسًا ليظهر في الصورة.",
            fromSelection: "شارك كاقتباس",
            preview: "معاينة الصورة",
            shareText: "من كتاب «{title}»"
        }
    },

    share: {
        share: "مشاركة",
        copyLink: "نسخ الرابط",
        linkCopied: "تم نسخ الرابط",
        email: "البريد الإلكتروني",
        moreOptions: "خيارات أخرى"
    },

    audiobooks: {
        seoTitle: "كتب صوتية إسلامية باللغة الألبانية",
        seoDescription:
            "كتب صوتية دينية وتربوية باللغة الألبانية، مقروءة بوضوح واحترافية. استمع إليها مباشرة في الصفحة، في أي وقت ومن أي جهاز.",
        listName: "الكتب الصوتية من معهد جيرما",
        title: "كتب صوتية باللغة الألبانية",
        description:
            "إصداراتنا بصيغة صوتية باللغة الألبانية. يمكنك الاستماع إليها مباشرة في هذه الصفحة أو تحميلها مجانًا دون تسجيل.",
        crumb: "الكتب الصوتية",
        comingSoon: "قريبًا",
        comingSoonText: "نعمل على إعداد كتبنا الصوتية. تابع قنواتنا لتكون من أوائل المستمعين.",
        badge: "كتاب صوتي",
        author: "المؤلف:",
        openBook: "افتح الكتاب",
        resumeFrom: "تابع من {time}",
        back15: "رجوع 15 ثانية",
        forward15: "تقديم 15 ثانية",
        play: "تشغيل",
        pause: "إيقاف مؤقت",
        position: "موضع الاستماع",
        speedGroup: "سرعة الاستماع",
        speed: "السرعة",
        speedValue: "السرعة {value}",
        download: "تحميل الكتاب الصوتي",
        youtube: "استمع على يوتيوب",
        miniLabel: "يُستمع إليه الآن",
        closePlayer: "إغلاق المشغّل",
        openAudiobook: "الانتقال إلى الكتاب الصوتي",
        coverAlt: "غلاف الكتاب الصوتي {title}",
        otherAudiobooks: "كتب صوتية أخرى",
        allAudiobooks: "جميع الكتب الصوتية",
        openPage: "افتح صفحة الكتاب الصوتي",
        pageSeoDescription: "استمع مجانًا إلى الكتاب الصوتي «{title}» باللغة الألبانية مباشرة على الصفحة، أو نزّله دون تسجيل."
    },

    videos: {
        seoTitle: "دروس مرئية لتعلّم قراءة القرآن الكريم",
        seoDescription:
            "{count} درسًا مرئيًا مجانيًا لتعلّم حروف القرآن الكريم بالألبانية والألمانية والإنجليزية، من الحرف الأول حتى القراءة المتقنة.",
        listName: "الدروس المرئية من معهد جيرما",
        title: "تعلّم قراءة القرآن الكريم",
        description:
            "تساعدك الدروس المرئية للأبجدية القرآنية على تعلّم الحروف العربية وقراءة القرآن الكريم خطوة بخطوة. الدروس متاحة بالألبانية والألمانية والإنجليزية، ويمكنك متابعتها مجانًا في هذه الصفحة دون تسجيل.",
        crumb: "الدروس المرئية",
        chooseLanguage: "اختر اللغة:",
        player: {
            videos: "فيديو",
            youtube: "شاهد على يوتيوب",
            list: "قائمة الدروس",
            promo: "فيديو تعريفي",
            promoShort: "تعريف",
            lesson: "الدرس",
            of: "من",
            playing: "قيد التشغيل",
            shareLesson: "مشاركة الدرس",
            openBook: "عرض الكتاب",
            markDone: "تحديد كدرسٍ مُتقَن",
            done: "تم إتقانه",
            progress: "تم إتقانها",
            resume: "تابع:",
            lessonsDone: "تعلّمت {done} من {total} درسًا",
            progressLabel: "التقدّم في هذه السلسلة",
            seriesDone: "لقد أتممت هذه السلسلة. أحسنت!",
            progressHint: "ضع علامة على الدروس التي تعلّمتها وتابع تقدّمك.",
            prevLesson: "الدرس السابق",
            nextLesson: "الدرس التالي",
            allLessons: "جميع دروس السلسلة",
            watchOnYoutube: "شاهد على يوتيوب",
            aboutLesson: "عن هذا الدرس",
            backToSeries: "العودة إلى السلسلة",
            openLessonPage: "افتح صفحة الدرس",
            lessonIntro: "الدرس {number} من {total} في سلسلة «{series}».",
            promoIntro: "الفيديو التعريفي لسلسلة «{series}».",
            freeLesson: "درس مرئي مجاني من معهد جيرما، دون تسجيل."
        }
    },

    courses: {
        seoTitle: "دورات القرآن الكريم واللغات",
        seoDescription:
            "دورات في القرآن الكريم من الحروف الأولى حتى القراءة بالتجويد، إضافةً إلى دورات اللغات. عن بُعد وحضوريًا، والتسجيل مفتوح.",
        listName: "دورات معهد جيرما",
        title: "دورات قراءة القرآن الكريم وتعلّم اللغات",
        description:
            "ننظّم دورات للمبتدئين ولمن يرغب في تطوير معارفه. وتُعقد الدروس عن بُعد أو حضوريًا بحسب الدورة والمجموعة.",
        crumb: "الدورات",
        posterAlt: "ملصق دورة {title}",
        teacher: "المعلّمة:",
        details: "اطّلع على تفاصيل الدورة",
        listTitle: "دوراتنا",
        listDescription:
            "ننظّم دورات في قراءة القرآن الكريم والتجويد، ونخطّط لاستئناف دورة اللغة العربية. ويُعلَن عن المواعيد والأوقات وطريقة التسجيل لكل مجموعة جديدة.",
        registerTitle: "هل ترغب في التسجيل في إحدى الدورات؟",
        registerDescription:
            "املأ النموذج لتعبّر عن اهتمامك. وفور افتتاح مجموعة جديدة للدورة التي اخترتها، سنتواصل معك لإبلاغك بموعد البدء والجدول وطريقة سير الدروس.",
        plannedSuffix: "يُخطَّط لاستئنافها",
        contactFallback: "تواصل معنا",
        items: {
            "shkronjat-e-kuranit": {
                title: "تعلّم قراءة القرآن الكريم",
                description:
                    "دورة للمبتدئات، وفق كتاب الأبجدية القرآنية. تبدأ بالتعرّف على الحروف العربية ونطقها، ثم وصلها في كلمات، مع تمارين على قراءة القرآن الكريم.",
                level: "للمبتدئات",
                format: "عن بُعد",
                badge: "للمبتدئين",
                summary:
                    "دورة وفق كتاب الأبجدية القرآنية، تبدأ بالتعرّف على الحروف العربية ونطقها، ثم وصلها في كلمات مع تمارين على القراءة.",
                cta: "استفسر عن المجموعات الجديدة"
            },
            "leximi-me-texhvid": {
                title: "تعلّم التجويد",
                description:
                    "تعلّم أحكام التجويد وتطبيقها، مع تمارين عملية وتصحيح للتلاوة.",
                level: "لمن يُحسن قراءة القرآن الكريم",
                format: "عن بُعد",
                badge: "",
                summary: "",
                cta: "استفسر عن المجموعات الجديدة"
            },
            "gjuha-arabe": {
                title: "اللغة العربية",
                description:
                    "دورة لتعلّم القراءة والكتابة والفهم باللغة العربية. وستُنشر التفاصيل عند تحديد موعد استئناف الدورة.",
                level: "يُخطَّط لاستئنافها",
                format: "عن بُعد",
                badge: "",
                summary: "",
                cta: "تواصل معنا لمزيد من المعلومات"
            }
        }
    },

    courseForm: {
        name: "الاسم الكامل",
        phone: "رقم الهاتف",
        email: "البريد الإلكتروني",
        course: "الدورة التي تهمّك",
        message: "رسالة",
        optional: "(اختياري)",
        messagePlaceholder: "اكتب أسئلتك أو طلباتك.",
        notice: "تعبئة النموذج لا تُعدّ تسجيلًا نهائيًا في الدورة.",
        submit: "أرسل الطلب",
        submitting: "جارٍ الإرسال…",
        successTitle: "تم إرسال الطلب",
        successText:
            "شكرًا لاهتمامك. سنتواصل معك عند افتتاح مجموعة جديدة للدورة التي اخترتها.",
        again: "أرسل طلبًا آخر",
        errors: {
            name: "يُرجى كتابة اسمك.",
            phone: "يُرجى كتابة رقم هاتف صحيح.",
            email: "يُرجى كتابة بريد إلكتروني صحيح.",
            course: "يُرجى اختيار دورة.",
            generic: "تعذّر إرسال الطلب. يُرجى المحاولة مرة أخرى."
        }
    },

    contact: {
        seoTitle: "اتصل بنا",
        seoDescription:
            "راسل معهد جيرما لطلب الكتب أو للتسجيل في دورات القرآن الكريم واللغات أو لاقتراح تعاون. نردّ في أقرب وقت ممكن.",
        title: "تواصل معنا",
        description:
            "راسلنا لطلب الكتب، أو للتسجيل في الدورات، أو لاقتراح تعاون، أو للاستفسار عن عملنا.",
        crumb: "اتصل بنا",
        howTitle: "كيف تتواصل معنا؟",
        howText: "يمكنك مراسلتنا عبر البريد الإلكتروني أو من خلال النموذج.",
        email: "البريد الإلكتروني",
        response: "مدة الرد",
        responseValue: "خلال 3 أيام",
        follow: "تابعنا على وسائل التواصل الاجتماعي"
    },

    contactForm: {
        name: "الاسم الكامل",
        namePlaceholder: "اسمك الكامل",
        email: "البريد الإلكتروني",
        emailPlaceholder: "you@example.com",
        subject: "الموضوع",
        optional: "(اختياري)",
        subjectPlaceholder: "عمَّ تودّ أن تكتب إلينا؟",
        message: "الرسالة",
        messagePlaceholder: "اكتب رسالتك هنا.",
        submit: "أرسل الرسالة",
        submitting: "جارٍ الإرسال…",
        successTitle: "شكرًا لك!",
        successText: "تم إرسال رسالتك بنجاح، وسنردّ عليك في أقرب وقت ممكن.",
        again: "أرسل رسالة أخرى",
        errors: {
            name: "يُرجى كتابة اسمك.",
            email: "يُرجى كتابة بريد إلكتروني صحيح.",
            message: "يُرجى كتابة رسالة أطول قليلًا.",
            generic: "تعذّر إرسال الرسالة. يُرجى المحاولة مرة أخرى."
        }
    },

    about: {
        seoTitle: "من نحن",
        seoDescription:
            "معهد جيرما مؤسسة ثقافية وتعليمية أسّسها يوسف كاستراتي، تُعنى بالنشر والترجمة ودورات القرآن الكريم واللغات.",
        title: "معهد جيرما",
        description: "في خدمة العلم والتعليم، عبر الكتاب والتدريس.",
        crumb: "من نحن",
        missionTitle: "رسالتنا",
        mission: [
            "معهد جيرما مؤسسة ثقافية وتعليمية تعمل في مجالات النشر والترجمة والتدريس. ننشر الكتب الدينية واللغوية والتربوية، وننظّم دورات في قراءة القرآن الكريم وتعلّم اللغات، ونُعدّ الدروس المرئية والمواد التعليمية.",
            "نولي في إصداراتنا عناية خاصة بدقة المحتوى وجودة الترجمة والتحرير اللغوي، ونجمع في دوراتنا بين الشرح والتمارين العملية، بما يناسب مستوى الدارسين واحتياجاتهم."
        ],
        valuesTitle: "المبادئ التي نعمل بها",
        values: [
            {
                title: "الدقة",
                text: "نعتمد على المصادر الموثوقة، ونراجع المحتوى قبل نشره حرصًا على سلامته الشرعية واللغوية."
            },
            {
                title: "الوضوح",
                text: "نستخدم لغة سلسة وشرحًا مفهومًا، ونوضّح المصطلحات والمسائل التي تتطلّب معرفة مسبقة."
            },
            {
                title: "العناية بالدارس",
                text: "نكيّف الدروس بحسب أعمار الدارسين ومعارفهم، ونفسح المجال لأسئلتهم، ونعينهم على التقدّم خطوة بخطوة."
            },
            {
                title: "المسؤولية",
                text: "نرحّب بالملاحظات والاقتراحات، ونصحّح ما يُلاحظ من أخطاء في إصداراتنا وموادنا."
            }
        ],
        leadership: "الإدارة",
        founderShort: "المؤسس والمدير",
        portraitAlt: "صورة {name}",
        directorRole: "مؤسس معهد جيرما ومديره",
        directorBio: [
            "يتولّى إدارة معهد جيرما مؤسسه الداعية يوسف كاستراتي، الحاصل على درجة البكالوريوس في الفقه وأصوله من كلية الشريعة بجامعة الإمام محمد بن سعود الإسلامية في الرياض، ودرجة الماجستير في الثقافة الإسلامية من الجامعة نفسها. ويواصل حاليًا دراسته لنيل درجة الدكتوراه في الحضارة الإسلامية بجامعة الزيتونة في تونس.",
            "وله خبرة طويلة في ترجمة الكتب الإسلامية والتدريس؛ إذ ترجم عددًا من الكتب الإسلامية إلى اللغة الألبانية، وقدّم دورات تعليمية في قراءة القرآن الكريم واللغة العربية، كما أولى التربية الإسلامية للناشئة والشباب اهتمامًا خاصًّا في عمله الدعوي والتعليمي."
        ]
    },

    kurani: {
        seoTitle: "القرآن الكريم مع ترجمة معانيه إلى اللغة الألبانية",
        seoDescription:
            "اقرأ النص العربي للقرآن الكريم مع ترجمة معانيه إلى اللغة الألبانية التي أعدّها يوسف كاستراتي، مجانًا على Kurani.info.",
        title: "القرآن الكريم",
        subtitle: "ترجمة معانيه إلى اللغة الألبانية",
        description:
            "اقرأ القرآن الكريم مع ترجمة معانيه إلى اللغة الألبانية التي أعدّها يوسف كاستراتي. الترجمة متاحة مجانًا على موقع Kurani.info.",
        crumb: "القرآن الكريم",
        readOn: "اقرأ على Kurani.info",
        logoAlt: "شعار منصة Kurani.info",
        aboutTitle: "عن الترجمة",
        about: [
            "أُعدّت هذه الترجمة لتنقل إلى القارئ الألباني معاني الآيات بدقة، وبلغة ألبانية واضحة سلسة. وقد اعتمدت على كتب التفسير المعتمدة، ومرّت بمراجعات شرعية ولغوية عديدة.",
            "كل ترجمة جهدٌ بشري لنقل معاني الآيات، ولا يمكنها أن تحيط بثراء الأصل اللغوي والدلالي إحاطة تامة؛ ولذلك فهي عونٌ على فهم القرآن الكريم، أما القرآن نفسه فهو كتاب الله المنزَّل باللغة العربية."
        ],
        featuresTitle: "خصائص الترجمة",
        features: [
            {
                title: "الدقة والأمانة",
                text: "عناية بنقل معاني الآيات، بالاعتماد على كتب التفسير المعتمدة."
            },
            {
                title: "ألبانية واضحة سلسة",
                text: "لغة ألبانية واضحة سلسة تحرص، قدر ما تسمح به اللغة، على الحفاظ على خصائص الأسلوب القرآني."
            },
            {
                title: "اتساق الأسلوب والمصطلحات",
                text: "استخدام متّسق للمصطلحات، مع الإبقاء على المصطلحات الإسلامية المعروفة في اللغة الألبانية."
            },
            {
                title: "حواشٍ موجزة",
                text: "إيضاحات تعين القارئ على فهم الآيات حيث تدعو الحاجة إلى شرح إضافي."
            },
            {
                title: "مراجعة شرعية ولغوية",
                text: "مراجعات متكرّرة من متخصصين في المجالات المعنية، لضمان دقة المعاني وسلامة التعبير الألباني."
            },
            {
                title: "إتاحة مجانية",
                text: "يمكن قراءة الترجمة مجانًا على الإنترنت، وتتيح النسخة الإلكترونية تحديثها بتصحيحات وتحسينات لاحقة."
            }
        ],
        translatorBadge: "المترجم",
        translatorRole: "باحث دكتوراه في الحضارة الإسلامية",
        translatorText:
            "ترجمة معاني القرآن الكريم إلى اللغة الألبانية ثمرة سنوات طويلة من البحث والترجمة والتحرير.",
        teamTitle: "فريق التحرير والمراجعة",
        roles: {
            religious: "مراجعة شرعية",
            consulting: "استشارة شرعية",
            language: "تحرير لغوي"
        },
        noteTitle: "ملاحظة",
        note: "هذه الترجمة في المراحل الأخيرة من التحرير والمراجعة العلمية، ونرحّب بكل ملاحظة أو اقتراح يُسهم في نقل معاني القرآن الكريم بأقصى قدر من الدقة.",
        writeUs: "راسلنا",
        ctaTitle: "اقرأ الترجمة",
        ctaText: "تجد النص العربي والترجمة الألبانية والحواشي التوضيحية على موقع Kurani.info.",
        ctaButton: "افتح Kurani.info"
    },

    search: {
        open: "بحث",
        title: "البحث في البوابة",
        placeholder: "ابحث عن كتب، كتب صوتية، دروس مرئية، دورات…",
        close: "إغلاق البحث",
        hint: "اكتب حرفين على الأقل للبحث.",
        empty: "لا توجد نتائج لـ «{query}».",
        error: "تعذّر البحث. يُرجى المحاولة بعد قليل.",
        loading: "جارٍ البحث…",
        groups: {
            books: "الكتب",
            audiobooks: "الكتب الصوتية",
            videos: "الدروس المرئية",
            courses: "الدورات"
        }
    },

    offline: {
        title: "أنت غير متصل بالإنترنت",
        text: "لم تُحفظ هذه الصفحة على هذا الجهاز بعد. أعد المحاولة عند عودة الاتصال. وفي الأثناء يمكنك قراءة الكتب التي فتحتها من قبل.",
        retry: "أعد المحاولة",
        home: "الصفحة الرئيسية",
        savedTitle: "كتب محفوظة للقراءة دون إنترنت",
        savedEmpty: "لا توجد كتب محفوظة بعد. كل كتاب تفتحه في قارئ الموقع يُحفظ تلقائيًا على هذا الجهاز."
    },

    pwa: {
        install: "ثبّت التطبيق"
    },

    notFound: {
        title: "الصفحة غير موجودة",
        text: "ربما نُقلت الصفحة أو لم تعد موجودة. عُد إلى الصفحة الرئيسية لتواصل رحلتك مع العلم.",
        back: "العودة إلى الرئيسية"
    },

    serverError: {
        title: "حدث خطأ ما",
        text: "حدث خطأ غير متوقّع من جهتنا. يُرجى المحاولة مرة أخرى بعد قليل.",
        back: "العودة إلى الرئيسية"
    }
}
